import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import ActionBar from './ActionBar';

type Props = {
  open: boolean;
  style?: Object;
  buttonText: string;
  onClick: () => void;
};

const DeleteBar = ({ open = false, style = {}, buttonText, onClick }: Props) => (
  <ActionBar open={open} style={{ position: 'fixed', ...style }}>
    <Button type="primary" danger icon={<DeleteOutlined />} onClick={onClick}>
      {buttonText}
    </Button>
  </ActionBar>
);

export default DeleteBar;
